import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { ClientsSection } from '../components/ClientsSection';
import { FAQSection } from '../components/FAQSection';
import { JobVacancies } from '../components/JobVacancies';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { FAQSchema } from '../components/FAQSchema';
export function HomePage() {
  return <div className="min-h-screen bg-white" data-id="element-496">
      <SEOHead page="home" data-id="element-497" />
      <FAQSchema data-id="element-498" />
      <Header data-id="element-499" />
      <main data-id="element-500">
        <HeroSection data-id="element-501" />
        <ServicesSection data-id="element-502" />
        <ClientsSection data-id="element-503" />
        <FAQSection data-id="element-504" />
        <JobVacancies data-id="element-505" />
        <ContactSection data-id="element-506" />
      </main>
      <Footer data-id="element-507" />
    </div>;
}